import { Component, ElementRef, Input, ViewChild, OnInit, OnChanges, HostListener, OnDestroy } from '@angular/core';
import * as d3 from 'd3';
import { DevicesService } from '../../../../devices/devices.service';
import { Device as Device_new } from '../../../../devices/devices.model_new';
import { Router } from '@angular/router';
import { SessionStateService } from '../../../../../core/services/session-state.service';
import { EnergyService } from '../../../../energy/energy.service';
import { HomeService } from '../../../home.service';
import { STATE_VAR, CONNECTIVITY_STATE } from '../../../../devices/devices.constant';
import { SharedUtils } from '../../../../../shared/shared.utils';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-bubble-chart',
  styleUrls: ['./bubble-chart.component.scss'],
  template: `
  <div class='bubble-chart' #bubbleChartContainer>
  </div>
  <div class='bubble-chart-error'>
    <img id="bubble-error" src="./assets/img/icons/ilust-cells-view@3x.png">
    <img id="errorIcon" src="./assets/img/icons/alert.svg">
    <span>
      <span id="errorMsg">The cells view is not optimised with your current browser. Please open EDP Re:dy application in <span style="color: #ea524b"> Chrome </span> to take advantage of all the features.</span>
    </span>
  </div>
`
})
export class BubbleChartComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('bubbleChartContainer') private chartContainer: ElementRef;

  @Input() devices;

  @Input() cellsContainerLen: number;
  isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  maxDeviceInCell = 10;
  svg: any;
  pack: any;
  transition: number;
  color: any;
  bubbles: Array<any> = [];
  power = 0;
  pkid: string;
  hostElement: any;
  hostElementWidth: number;
  first = true;

  maxX = -1000;
  minX = -1000;

  maxY = 1000;
  minY = 1000;

  children;
  updateChartThread;
  selfConsumptionBubblesThread: any[] = [];

  isIEOrEdgeOrFirefox: boolean;

  outOfTab;
  noActiveBubbles: boolean;

  constructor(
    private sessionStateService: SessionStateService,
    private elementRef: ElementRef,
    private router: Router,
    private homeService: HomeService) { }

  // In order to fix memory issues ==> When screen is not being shown the animation of selfConsumption is stopped
  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if (this.homeService.isAutoConsumption() || this.homeService.isAutoConsumptionWithBattery()) {
      if(document.hidden) {
        this.stopAutoConsumptionAnimation();
      } else {
        this.createAutoConsumptionAnimation();
      }
    }
  }

  ngOnInit() {
    if (window.innerWidth <= 1366 && (this.homeService.isAutoConsumption() || this.homeService.isAutoConsumptionWithBattery())) {
      this.cellsContainerLen = this.cellsContainerLen + 80;
    }

    this.isIEOrEdgeOrFirefox = /msie\s|trident\/|edge\/|firefox\/|safari/i.test(window.navigator.userAgent);

    this.hostElement = this.chartContainer.nativeElement;
    this.bubbles = this.getBubbles();
    if (this.hostElement && this.hostElement.offsetWidth !== 0 && this.hostElement.offsetWidth !== this.hostElementWidth) {
      this.hostElementWidth = this.hostElement.offsetWidth;
      d3.select('.bubble-chart svg').remove();
      this.createChart();
      this.updateChart();
      this.startChartUpdate();
    }
  }

  private startChartUpdate(): void {
    this.updateChartThread = setInterval(() => {
      this.updateChart();
    }, 5000);
  }

  // @HostListener('window:focus', ['$event.target'])
  // onFocus(target: any) {
  //   this.outOfTab = false;
  //   this.updateChart();
  //   this.startChartUpdate();
  //   if (this.homeService.isAutoConsumption() ||
  //     this.homeService.isAutoConsumptionWithBattery()) {
  //     this.createAutoConsumptionAnimation();
  //   }
  // }

  ngOnChanges() {
    this.bubbles = this.getBubbles();
  }

  createChart() {
    this.transition = 700;
    const width = this.hostElement.offsetHeight - 100;
    const height = this.hostElement.offsetHeight - 100;

    this.svg = d3.select(this.hostElement)
      .append('svg')
      .attr('width', this.cellsContainerLen - 100)
      .attr('height', this.cellsContainerLen - 100);

    this.svg.append('defs')
      .append('filter')
      .attr('id', 'f1')
      .attr('x', '-40%')
      .attr('y', '-40%')
      .attr('height', '200%')
      .attr('width', '200%');

    // <feDropShadow dx="0" dy="0" stdDeviation="5" flood-opacity="0.20"></feDropShadow>

    if (!this.isIEOrEdgeOrFirefox) {
      this.svg.select('#f1')
        .append('feDropShadow')
        .attr('dx', '0')
        .attr('dy', '0')
        .attr('stdDeviation', '5')
        .attr('flood-opacity', '0.10');
    }

    // this.svg.select('#f1')
    //   .append('feOffset')
    //   .attr('result', 'offOut')
    //   .attr('in', 'SourceAlpha')
    //   .attr('dx', '0')
    //   .attr('dy', '0');

    // this.svg.select('#f1')
    //   .append('feGaussianBlur')
    //   .attr('result', 'blurOut')
    //   .attr('in', 'offOut')
    //   .attr('stdDeviation', '2');

    // this.svg.select('#f1')
    //   .append('feBlend')
    //   .attr('in', 'SourceGraphic')
    //   .attr('in2', 'blurOut')
    //   .attr('mode', 'normal');


    this.svg.select('defs')
      .append('filter')
      .attr('id', 'f2')
      .attr('x', '-40%')
      .attr('y', '-40%')
      .attr('height', '200%')
      .attr('width', '200%');

    if (!this.isIEOrEdgeOrFirefox) {
      this.svg.select('#f2')
        .append('feDropShadow')
        .attr('dx', '0')
        .attr('dy', '0')
        .attr('stdDeviation', '5')
        .attr('flood-opacity', '0.30');
    }

    // this.svg.select('#f2')
    //   .append('feOffset')
    //   .attr('result', 'offOut')
    //   .attr('in', 'SourceAlpha')
    //   .attr('dx', '0')
    //   .attr('dy', '0');

    // this.svg.select('#f2')
    //   .append('feGaussianBlur')
    //   .attr('result', 'blurOut')
    //   .attr('in', 'offOut')
    //   .attr('stdDeviation', '5');

    // this.svg.select('#f2')
    //   .append('feBlend')
    //   .attr('in', 'SourceGraphic')
    //   .attr('in2', 'blurOut')
    //   .attr('mode', 'normal');

    this.svg.append('g')
      .attr('id', 'consBubbles')
      .attr('transform', 'translate(' + this.cellsContainerLen / 10 + ',' + this.cellsContainerLen / 10 + ')');

    this.svg.select('g')
      .append('path')
      .attr('id', 'outlineSw');

    this.svg.select('g')
      .append('path')
      .attr('id', 'outlineSwRotate');

    this.svg.select('g')
      .append('path')
      .attr('id', 'outline')
      .on('click', this.onList);

    this.pack = d3.pack()
      .size([this.cellsContainerLen - 240, this.cellsContainerLen - 240])
      .padding(25);

    this.color = d3.scaleOrdinal(d3.schemeCategory20c);

    if (this.homeService.isAutoConsumption() ||
      this.homeService.isAutoConsumptionWithBattery()) {
      this.createAutoConsumptionAnimation();
    } else if (this.homeService.isMicroGeneration()) {
      this.createMicrogenerationAnimation();
    }
  }

  private randomInc2(): number {
    return (Math.random() * (Math.floor(Math.random() * 2) === 1 ? 1 : -1)) * 30;
  }


  private createMicrogenerationAnimation() {

    this.svg.append('defs')
      .append('filter')
      .attr('id', 'blur')
      .append('feGaussianBlur')
      .attr('stdDeviation', 4);

    this.svg.append('circle')
      .attr('cx', 300)
      .attr('cy', 40)
      .attr('r', 30)
      .attr('filter', 'url(#blur)')
      .style('fill', '#a0d7f8')
      .attr('cursor', 'pointer');

    this.svg.append('circle')
      .attr('cx', 300)
      .attr('cy', 40)
      .attr('r', 25)
      .attr('filter', 'url(#blur)')
      .style('fill', '#69b9e7')
      .attr('cursor', 'pointer');

    // this.updateMicrogenerationAnimation(500);
    // setInterval(() => {
    //   this.updateMicrogenerationAnimation(500);
    // }, 500);

  }

  private updateMicrogenerationAnimation(duration: number) {
    const nodeBlue = this.svg.select('circle');
    const cx = nodeBlue._groups['0']['0'].cx.animVal.value;
    const cy = nodeBlue._groups['0']['0'].cy.animVal.value;
    nodeBlue
      .transition()
      .ease(d3.easeLinear)
      .duration(duration)
      .attr('cx', function (d) { return cx + ((Math.random() * (Math.floor(Math.random() * 2) === 1 ? 1 : -1)) * 15); })
      .attr('cy', function (d) { return cy + ((Math.random() * (Math.floor(Math.random() * 2) === 1 ? 1 : -1)) * 15); });
  }

  private createAutoConsumptionAnimation() {
    this.stopAutoConsumptionAnimation();
    // this.svg.append('defs')
    //   .append('filter')
    //   .attr('id', 'blur')
    //   .append('feGaussianBlur')
    //   .attr('stdDeviation', 1);

    const animationDuration = 2500;

    // for (let i = 0; i < animationDuration; i = i + 250) {
    //   setTimeout(() => {
    //     this.addBubbles(i);
    //     this.moveBubbles(i, animationDuration);
    //   }, i);
    // }

    for (let i = 0; i < animationDuration; i = i + 250) {
      setTimeout(() => {
        const intervalId = setInterval(() => {
          this.cleanBubbles(i);
          this.addBubbles(i);
          this.moveBubbles(i, animationDuration);
        }, animationDuration);
        this.selfConsumptionBubblesThread.push(intervalId);
      }, i);
    }
  }

  stopAutoConsumptionAnimation() {
    this.selfConsumptionBubblesThread.forEach((id) => clearInterval(id));
    this.selfConsumptionBubblesThread = [];
  }

  cleanBubbles(type: number) {
    const nodeBlue = this.svg.selectAll('.blue');
    nodeBlue.remove();
  }

  addBubbles(type: number) {
    if (!this.outOfTab) {
      const bubblesNr = 5;
      const bubblesMaxSize = 3;

      for (let i = 0; i < bubblesNr; i++) {
        this.svg.append('circle')
          .attr('class', 'blue' + type)
          .attr('cx', 350 + ((Math.random() * (Math.floor(Math.random() * 2) === 1 ? 1 : -1)) * 20))
          .attr('cy', 25 + ((Math.random() * (Math.floor(Math.random() * 2) === 1 ? 1 : -1)) * 20))
          .attr('r', bubblesMaxSize / (Math.floor(Math.random() * 2) + 1))
          // .attr('filter', 'url(#blur)')
          .style('fill', !!Math.floor(Math.random() * 2) ? '#63bcef' : '#3094cf')
          .attr('cursor', 'pointer');
      }
    }
  }

  moveBubbles(type: number, duration: number) {
    const nodeBlue = this.svg.selectAll('.blue' + type);
    const cx = nodeBlue._groups['0']['0'].cx.animVal.value;
    const cy = nodeBlue._groups['0']['0'].cy.animVal.value;
    nodeBlue
      .transition()
      .ease(d3.easeLinear)
      .attr('cx', function (d) { return 250; })
      .attr('cy', function (d) { return 85; })
      .on('end', function () {
        d3.select(this).remove();
      })
      .duration(duration - 100);
  }

  updateChart() {
    const hierarchy = d3.hierarchy({ children: this.bubbles })
      .sum((d: any) => {
        if (d.children) {
          return 0;
        }
        return d.power;
      });

    // JOIN
    const node = this.svg.select('#consBubbles')
      .selectAll('g')
      .data(this.pack(hierarchy).leaves());

    const nodeEnter = node.enter()
      .append('g');

    if (!this.isIEOrEdgeOrFirefox) {
      nodeEnter.attr('filter', 'url(#f1)')
        .on('mouseover', function () { d3.select(this).style('filter', 'url(#f2)'); })
        .on('mouseout', function () { d3.select(this).style('filter', 'url(#f1)'); });
    }

    nodeEnter.attr('transform', d => 'translate(' + d.x + ', ' + d.y + ')');

    // ENTER
    nodeEnter.append('circle')
      .attr('fill', d => d.data.outOfOrder ? '#D0B8B8' :
        (((!d.data.relayState && d.data.relayState !== undefined) || !d.data.hasPower) ? '#F6DFDF' : '#ffffff'))
      .attr('stroke',
        d => (!d.data.hasPower && !d.data.outOfOrder) ? '#ffffff' :
          (d.data.outOfOrder ? '#C7B0B0' : ((d.data.relayState || d.data.relayState === undefined) ? '#ea524b' : '#4f4f4f')))
      .attr('r', d => !isNaN(d.r) ? d.r : 0)
      .attr('cursor', 'pointer')
      .on('click', this.onDetail)
      // .on('click', function(d, i)  {
      //   d3.select(this).style('fill', 'magenta');
      //   return this.onDetail();
      // })
      .transition()
      .duration(700);

    nodeEnter.append('text')
      .attr('filter', 'none')
      .attr('dy', '.3em')
      .attr('text-anchor', 'middle')
      .text(d => d.data.label)
      .attr('fill',
        d => (!d.data.hasPower && !d.data.outOfOrder) ? '#ffffff' :
          (d.data.outOfOrder ? '#F0E9E9' : ((d.data.relayState || d.data.relayState === undefined) ? '#ea524b' : '#4f4f4f')))
      .attr('font-family', 'Roboto')
      .attr('font-size', 14)
      .attr('cursor', 'pointer')
      .on('click', this.onDetail);

    this.maxX = -1000;
    this.minX = 1000;
    this.maxY = -1000;
    this.minY = 1000;

    for (let i = 0, len = hierarchy.children ? hierarchy.children.length : 0; i < len; i++) {
      const c = hierarchy.children[i];
      // let oldC;
      // if (this.children !== undefined) {
      //   oldC = this.children.find(n => n.data.pkid === hierarchy.children[i].data.pkid);
      //   console.log(i);
      //   console.log(oldC['r']);
      // }
      c['x'] += this.randomInc();
      c['y'] += this.randomInc();

      // if (this.children !== undefined) {
      //   c['r'] = oldC / (c['r']);
      // }

      const factorXr = 25;
      const factorXl = 55;
      const factorYt = 25;
      const factorYb = 75;

      if (c['x'] + c['r'] + factorXl > this.maxX) {
        this.maxX = c['x'] + c['r'] + factorXl;
      }

      if (c['x'] - c['r'] - factorXr < this.minX) {
        this.minX = c['x'] - c['r'] - factorXr;
      }

      if (c['y'] + c['r'] + factorYb > this.maxY) {
        this.maxY = c['y'] + c['r'] + factorYb;
      }

      if (c['y'] - c['r'] - factorYt < this.minY) {
        this.minY = c['y'] - c['r'] - factorYt;
      }
    }

    this.children = cloneDeep(hierarchy.children);

    const middleX = (this.maxX - this.minX) / 2;
    const middleY = (this.maxY - this.minY) / 2;

    const q1X = this.minX * 1.20;
    const q1Y = this.minY * 1.20;

    const q2X = this.maxX * 0.85;
    const q2Y = this.minY * 1.20;

    const q3X = this.maxX * 0.85;
    const q3Y = this.maxY * 0.85;

    const q4X = this.minX * 1.20;
    const q4Y = this.maxY * 0.80;

    const factor = 2;
    const points =
      [[this.minX - factor, middleY],
      [q1X - factor, q1Y - factor],
      [middleX, this.minY - factor],
      [q2X + factor, q2Y - factor],
      [this.maxX + factor, middleY],
      [q3X + factor, q3Y + factor],
      [middleX, this.maxY + factor],
      [q4X - factor, q4Y + factor]];

    const swFactor = 10;
    const pointsSw =
      [[this.minX - swFactor, middleY],
      [q1X - swFactor, q1Y - swFactor],
      [middleX, this.minY - swFactor],
      [q2X + swFactor, q2Y - swFactor],
      [this.maxX + swFactor, middleY],
      [q3X + swFactor, q3Y + swFactor],
      [middleX, this.maxY + swFactor],
      [q4X - swFactor, q4Y + swFactor]];

    const halfLen = hierarchy.children ? (hierarchy.children.length / 2) : 0;

    node
      .select('circle')
      .attr('fill', d => d.data.outOfOrder ? '#D0B8B8' :
        (((!d.data.relayState && d.data.relayState !== undefined) || !d.data.hasPower) ? '#F6DFDF' : '#ffffff'))
      .attr('stroke',
        d => (!d.data.hasPower && !d.data.outOfOrder) ? '#ffffff' :
          (d.data.outOfOrder ? '#C7B0B0' : ((d.data.relayState || d.data.relayState === undefined) ? '#ea524b' : '#4f4f4f')))
      .attr('r', d => !isNaN(d.r) ? d.r : 0);

    node
      .select('text')
      .attr('fill',
        d => (!d.data.hasPower && !d.data.outOfOrder) ? '#ffffff' :
          (d.data.outOfOrder ? '#F0E9E9' : ((d.data.relayState || d.data.relayState === undefined) ? '#ea524b' : '#4f4f4f')));

    // UPDATE
    node
      .filter(function (d, i) { return i < halfLen; })
      .transition()
      .ease(d3.easeLinear)
      .duration(5000)
      .attr('transform', d => 'translate(' + d.x + ', ' + d.y + ')')
      .style('fill', '#3a403d');
    // UPDATE
    node
      .filter(function (d, i) { return i >= halfLen; })
      .transition()
      .ease(d3.easeLinear)
      .duration(4000)
      .attr('transform', d => 'translate(' + (d.x) + ', ' + d.y + ')')
      .style('fill', '#3a403d');

    const lineGenerator = d3.line();
    lineGenerator.curve(d3.curveBasisClosed);
    let linestring = lineGenerator(points);

    this.svg.select('#outline')
      .transition()
      .ease(d3.easeLinear)
      .duration(5000)
      .attr('d', linestring)
      .attr('stroke', '#ea524b')
      .attr('stroke-width', '1.5')
      .attr('fill', 'transparent')
      .attr('cursor', 'pointer');

    linestring = lineGenerator(pointsSw);

    this.svg.select('#outlineSw')
      .transition()
      .ease(d3.easeLinear)
      .duration(5000)
      .attr('d', linestring)
      .attr('fill', 'rgba(234, 82, 75, 0.07)');

    this.svg.select('#outlineSwRotate')
      .transition()
      .ease(d3.easeLinear)
      .duration(5000)
      .attr('transform', 'rotate(10 150 150)')
      .attr('d', linestring)
      .attr('fill', 'rgba(234, 82, 75, 0.07)');

    if (this.first) {
      this.first = false;
      this.updateChart();
    }
  }

  onDetail = (d, i) => {
    this.router.navigate([`/devices/${d.data.pkid}`]);
  }

  onList = () => {
    this.router.navigate(['/energy'], { queryParams: { energyType: 'CONSUMPTION' } });
  }

  private randomInc(): number {
    return (Math.random() * (Math.floor(Math.random() * 2) === 1 ? 1 : -1)) * 10;
  }

  private getBubbles(): Array<any> {
    const bubbles = [];
    this.devices.forEach((d: Device_new) => {
      if ( bubbles.length < this.maxDeviceInCell) {
        let power = this.getPower(d) ?
          d.getStateVar(STATE_VAR.ACTIVE_POWER_A_PLUS).value * 1000 : 1;
        power = power > 0 ? power : 5;
        power = power > 30 ? 30 : power;
        power = power < 5 ? 5 : power;
        if (!d.isStateVarSupported(STATE_VAR.ACTIVE_POWER_A_PLUS) && d.isOnline() ||
          d.isStateVarSupported(STATE_VAR.ACTIVE_POWER_A_PLUS))  {
          bubbles.push(
            {
              pkid: d.getModuleId(),
              label: SharedUtils.getDeviceInitials(d.getName()),
              power: power,
              hasPower: d.isStateVarSupported(STATE_VAR.ACTIVE_POWER_A_PLUS),
              relayState: this.getRelayState(d),
              outOfOrder: !d.isOnline()
            }
          );
        }
      }
    });
    // if (bubbles.length !== 0 && this.isChrome) {
    //   this.startCell();
    // } else {
    //   this.showCellError();
    // }
    this.startCell();
    return bubbles;
  }

  private getPower(d: Device_new): boolean {
    return d.isStateVarSupported(STATE_VAR.ACTIVE_POWER_A_PLUS) &&
      d.getStateVar(STATE_VAR.ACTIVE_POWER_A_PLUS).value && d.isOnline();
  }

  private getRelayState(d: Device_new): boolean {
    return d.isStateVarSupported(STATE_VAR.RELAY_STATE) ?
      d.getStateVar(STATE_VAR.RELAY_STATE) && d.getStateVar(STATE_VAR.RELAY_STATE).value : true;
  }

  mouseover = (d, i) => {
    d.attr('fill', 'red');
  }

  mouseout = () => {

  }

  ngOnDestroy() {
    if (this.updateChartThread) {
      clearInterval(this.updateChartThread);
    }
    this.selfConsumptionBubblesThread.forEach(id => clearInterval(id));
    this.selfConsumptionBubblesThread = [];
  }


  startCell() {
    const cell = document.getElementsByClassName('bubble-chart');
    cell[0].classList.add('active');
  }

  showCellError() {
    const cell = document.getElementsByClassName('bubble-chart-error');
    cell[0].classList.add('active');
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/home/home-tab/home-cells-view/bubble-chart/bubble-chart.component.ts